import { createFileRoute } from '@tanstack/react-router';

import { HiringJobsPage } from '@/features/hiring/jobs-page';

export const Route = createFileRoute('/_app/projects/$projectId/hiring/jobs/')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <HiringJobsPage projectId={projectId} />;
}
